import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";

/**
 * DS InfoBanner — figma 298:4208 "Frame 103" (readonly/info 안내 banner).
 *
 * bg: Yellow/10 (#FDF7E0), padding 40×12, gap 8 items-center.
 * icon: 16×16 Orange/50 (#FF8B3D)
 * text: Pretendard Regular 14/22, Text/Primary, SemiBold highlights 지원.
 *
 * @param {object} props
 * @param {React.ReactNode} props.children - 본문 (string 또는 JSX with bold spans)
 */
const DSInfoBanner = ({ children }) => {
  return (
    <div className="ds-info-banner" role="status">
      <FontAwesomeIcon
        icon={faCircleExclamation}
        className="ds-info-banner__icon"
      />
      <div className="ds-info-banner__text">{children}</div>
    </div>
  );
};

export default React.memo(DSInfoBanner);
